import React from 'react';
import { DashboardProvider } from 'contexts/dashboard.context';
import DashboardContent from './content';

const DashboardLayout = () => {
  return (
    <DashboardProvider>
      <DashboardContent />
    </DashboardProvider>
  );
};

export default DashboardLayout;
